// extracted by mini-css-extract-plugin
export var chip = "_bf-0";
export var filterDropdown = "_bf-5";
export var filterItem = "_bf-6";
export var icon = "_bf-1";
export var removeButton = "_bf-3";
export var removeIcon = "_bf-4";
export var separator = "_bf-2";